/* flow */
import React from 'react'
import './Leaf.css'
import logo from './assets/leaf_icon.svg'

export default () =>
    <img src={logo} className="ac-leaf" alt="leaf"/>



// WEBPACK FOOTER //
// ./src/Leaf.js